export default __webpack_public_path__ + "static/media/ogc-construction-green.0261ab91.svg";